import HttpClientError from '@errors/HttpClientError';
import { type MedicalSpecialty } from '@models/MedicalSpecialty';
import HttpClient from '@services/utils/HttpClient';

import { type IGetAllMedicalSpecialtiesInputData } from './dtos/getAllMedicalSpecialties/InputData';
import { type IGetAllMedicalSpecialtiesOutputData } from './dtos/getAllMedicalSpecialties/OutputData';
import { type IMedicalSpecialtyRepository } from './IMedicalSpecialtyRepository';

interface IGetAllParams {
  id: number;
}

interface IGetAllResponse {
  lista: {
    id: number;
    nome: string;
  }[];
}

class MedicalSpecialtyService implements IMedicalSpecialtyRepository {
  public async getAll(
    inputData: IGetAllMedicalSpecialtiesInputData,
  ): Promise<IGetAllMedicalSpecialtiesOutputData> {
    try {
      const response = await HttpClient.get<IGetAllResponse, IGetAllParams>({
        path: 'especialidades.php',
        params: {
          id: inputData.id,
        },
      });
      const output: IGetAllMedicalSpecialtiesOutputData = {
        list: response.data.lista.map((item) => {
          const medicalSpecialty: MedicalSpecialty = {
            id: item.id,
            name: item.nome,
          };
          return medicalSpecialty;
        }),
      };
      return output;
    } catch (err) {
      if (err instanceof HttpClientError) {
        throw new HttpClientError({
          body: err.body,
          message: err.message,
          response: err.response,
        });
      }
      if (err instanceof Error) {
        throw new Error(err.message);
      }
      throw new Error(String(JSON.stringify(err)));
    }
  }
}

export default new MedicalSpecialtyService();
